<div class="container-fluid collections-page">
  <app-work-context-bar />

  <section class="collections-lock" *ngIf="collectionsPinGateVisible" aria-label="Collections lock">
    <div class="collections-lock__card">
      <span class="collections-lock__mark" aria-hidden="true">
        <i class="pi" [ngClass]="pinBusy ? 'pi-spin pi-spinner' : 'pi-lock'"></i>
      </span>
      <p class="kicker">Financial reports</p>
      <h1>{{ pinReady ? collectionsPinTitle : 'Checking collections lock' }}</h1>
      <p class="collections-lock__hint">{{ pinReady ? collectionsPinHint : 'One moment.' }}</p>

      <label class="collections-lock__password" *ngIf="pinStep === 'reset-password'">
        <span>Login password</span>
        <input
          type="password"
          name="collections-pin-password"
          autocomplete="current-password"
          [(ngModel)]="pinPassword"
          (keydown.enter)="continueCollectionsPinReset()"
        />
      </label>

      <div class="collections-lock__dots" aria-hidden="true" *ngIf="pinStep !== 'reset-password' && pinReady">
        <span *ngFor="let filled of collectionsPinFilled" [class.is-on]="filled"></span>
      </div>

      <div class="collections-lock__pad" *ngIf="pinStep !== 'reset-password' && pinReady">
        <button type="button" *ngFor="let digit of pinPad" [disabled]="pinBusy" (click)="pushCollectionsPinDigit(digit)">{{ digit }}</button>
        <span aria-hidden="true"></span>
        <button type="button" [disabled]="pinBusy" (click)="pushCollectionsPinDigit('0')">0</button>
        <button type="button" [disabled]="pinBusy" (click)="popCollectionsPinDigit()" aria-label="Delete">
          <i class="pi pi-delete-left"></i>
        </button>
      </div>

      <p class="collections-lock__error" *ngIf="pinError">{{ pinError }}</p>

      <div class="collections-lock__links">
        <button type="button" class="is-primary" *ngIf="pinStep === 'reset-password'" [disabled]="pinBusy" (click)="continueCollectionsPinReset()">Continue</button>
        <button type="button" *ngIf="pinStep === 'unlock' && pinConfigured" (click)="startCollectionsPinReset()">Forgot PIN? Use login password</button>
        <button type="button" *ngIf="pinStep.startsWith('reset') || pinStep.startsWith('change')" (click)="cancelCollectionsPinFlow()">Cancel</button>
        <button type="button" *ngIf="pinCheckFailed" (click)="loadCollectionsPinStatus()">Try again</button>
      </div>
    </div>
  </section>

  <div class="collections-shell" *ngIf="!collectionsPinGateVisible" [class.is-loading]="loading">
    <section class="control-panel" aria-label="Collections controls">
      <div class="control-head">
        <div class="control-brand">
          <div class="control-brand__text">
            <span class="kicker">Analytics</span>
            <h1>Collections</h1>
          </div>
          <p class="control-meta" *ngIf="hasGenerated">
            {{ rangeLabel }}
            <span class="dot" aria-hidden="true">·</span>
            {{ doctorLabel }}
          </p>
        </div>

        <div class="control-head__actions">
          <button
            type="button"
            class="col-btn col-btn--ghost"
            *ngIf="pinRequired && pinUnlocked"
            (click)="startCollectionsPinChange()"
          >
            Change PIN
          </button>
          <button
            type="button"
            class="col-btn col-btn--ghost"
            *ngIf="pinRequired && pinUnlocked"
            (click)="lockCollections()"
          >
            <i class="pi pi-lock" aria-hidden="true"></i>
            Lock
          </button>
          <button
            type="button"
            class="col-btn col-btn--ghost"
            (click)="clearFilters()"
            pTooltip="Reset filters"
            tooltipPosition="bottom"
          >
            <i class="pi pi-filter-slash" aria-hidden="true"></i>
            Reset
          </button>
          <button
            type="button"
            class="col-btn col-btn--excel"
            [disabled]="exporting || (reportView === 'day' ? !report.daily_breakdown.length : !patientReport.patients.length)"
            (click)="exportActiveReport()"
          >
            <i class="pi" [ngClass]="exporting ? 'pi-spin pi-spinner' : 'pi-file-excel'" aria-hidden="true"></i>
            Export
          </button>
          <button
            type="button"
            class="col-btn col-btn--primary"
            [disabled]="loading"
            (click)="loadReport()"
          >
            <i class="pi" [ngClass]="loading ? 'pi-spin pi-spinner' : 'pi-check'" aria-hidden="true"></i>
            {{ loading ? 'Loading…' : 'Apply' }}
          </button>
        </div>
      </div>

      <div class="control-body">
        <div class="control-group" role="group" aria-label="Date range">
          <span class="group-label">Period</span>
          <div class="seg-track">
            <button
              type="button"
              class="seg-btn"
              *ngFor="let p of presets"
              [class.is-active]="activePreset === p.id"
              (click)="applyPreset(p.id)"
            >
              {{ p.label }}
            </button>
            <span class="seg-btn is-custom" *ngIf="activePreset === 'custom'">Custom</span>
          </div>

          <div class="date-picker-wrap">
            <p-calendar
              inputId="dateRange"
              [(ngModel)]="dateRange"
              (onSelect)="onDateRangeSelect()"
              (onClear)="onDateRangeSelect()"
              selectionMode="range"
              [readonlyInput]="true"
              [showIcon]="true"
              [showButtonBar]="true"
              [numberOfMonths]="2"
              dateFormat="dd M yy"
              placeholder="Select date range"
              appendTo="body"
              styleClass="range-calendar"
              inputStyleClass="range-calendar-input"
              panelStyleClass="collections-range-panel"
            ></p-calendar>
          </div>
        </div>

        <div class="control-rule" aria-hidden="true"></div>

        <div class="control-group" role="group" aria-label="Report type">
          <span class="group-label">Report</span>
          <div class="seg-track">
            <button
              type="button"
              class="seg-btn"
              [class.is-active]="reportView === 'day'"
              (click)="setReportView('day')"
            >
              By day
            </button>
            <button
              type="button"
              class="seg-btn"
              [class.is-active]="reportView === 'patient'"
              (click)="setReportView('patient')"
            >
              By patient
            </button>
          </div>
        </div>

        <div class="control-rule" aria-hidden="true"></div>

        <div class="control-group" role="group" aria-label="Doctor filter">
          <span class="group-label">Doctor</span>
          <div class="seg-track">
            <button
              type="button"
              class="seg-btn"
              [class.is-active]="filters.doctor_id === null"
              (click)="selectDoctor(null)"
            >
              All
            </button>
            <button
              type="button"
              class="seg-btn"
              *ngFor="let doctor of doctorsList"
              [class.is-active]="filters.doctor_id === doctor.value"
              (click)="selectDoctor(doctor.value)"
            >
              {{ doctor.label }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Spotlight + insights -->
    <section class="spotlight-grid" *ngIf="reportView === 'day' && hasGenerated" aria-label="Summary">
      <article class="spotlight-card">
        <div class="spotlight-main">
          <div class="spotlight-copy">
            <span class="spotlight-label">Total collected</span>
            <strong class="spotlight-value">₹{{ formatRupee(report.summary.total_collected) }}</strong>
            <p class="spotlight-sub">
              of
              <strong class="spotlight-fees">₹{{ formatRupee(report.summary.fees_generated) }}</strong>
              fees generated
            </p>

            <div class="mix-block">
              <div class="mix-labels">
                <span><i class="mix-dot mix-dot--cash" aria-hidden="true"></i> Cash {{ cashShare }}%</span>
                <span><i class="mix-dot mix-dot--online" aria-hidden="true"></i> Online {{ onlineShare }}%</span>
              </div>
              <div class="mix-track" role="img" [attr.aria-label]="'Cash ' + cashShare + ' percent, Online ' + onlineShare + ' percent'">
                <span class="mix-fill mix-fill--cash" [style.width.%]="cashShare"></span>
                <span class="mix-fill mix-fill--online" [style.width.%]="onlineShare"></span>
              </div>
              <div class="mix-amounts">
                <span class="amount-cash">₹{{ formatRupee(report.summary.cash_collected) }}</span>
                <span class="amount-online">₹{{ formatRupee(report.summary.online_collected) }}</span>
              </div>
            </div>
          </div>

          <div class="rate-ring" aria-label="Collection rate">
            <svg viewBox="0 0 120 120" aria-hidden="true">
              <circle class="rate-ring__track" cx="60" cy="60" r="54" />
              <circle
                class="rate-ring__value"
                cx="60"
                cy="60"
                r="54"
                [attr.stroke-dasharray]="rateCircumference"
                [attr.stroke-dashoffset]="rateOffset"
              />
            </svg>
            <div class="rate-ring__label">
              <strong>{{ collectionRate }}%</strong>
              <span>collected</span>
            </div>
          </div>
        </div>
      </article>

      <div class="stat-stack">
        <article class="stat-tile">
          <div class="stat-tile__icon"><i class="pi pi-users" aria-hidden="true"></i></div>
          <div>
            <span class="stat-tile__label">Appointments</span>
            <strong class="stat-tile__value">{{ report.summary.total_appointments | number }}</strong>
          </div>
        </article>
        <article class="stat-tile stat-tile--pending">
          <div class="stat-tile__icon"><i class="pi pi-clock" aria-hidden="true"></i></div>
          <div>
            <span class="stat-tile__label">Pending</span>
            <strong class="stat-tile__value">₹{{ formatRupee(report.summary.total_pending) }}</strong>
          </div>
        </article>
        <article class="stat-tile">
          <div class="stat-tile__icon"><i class="pi pi-chart-line" aria-hidden="true"></i></div>
          <div>
            <span class="stat-tile__label">Avg / day</span>
            <strong class="stat-tile__value">₹{{ formatRupee(avgDailyCollected) }}</strong>
          </div>
        </article>
        <article class="stat-tile">
          <div class="stat-tile__icon"><i class="pi pi-wallet" aria-hidden="true"></i></div>
          <div>
            <span class="stat-tile__label">Avg / patient</span>
            <strong class="stat-tile__value">₹{{ formatRupee(avgPerPatient) }}</strong>
          </div>
        </article>
      </div>
    </section>

    <!-- Chart + best day -->
    <section class="insight-grid" *ngIf="reportView === 'day' && hasGenerated && report.daily_breakdown.length" aria-label="Trends">
      <article class="chart-card">
        <div class="panel-head">
          <div>
            <h2>Daily trend</h2>
            <p>Fees generated vs collected — click a day to drill in</p>
          </div>
          <div class="chart-legend">
            <span class="chart-legend__item chart-legend__item--fees">Generated</span>
            <span class="chart-legend__item chart-legend__item--collected">Collected</span>
            <span class="panel-badge" *ngIf="bestDay">
              Peak {{ formatCompact(bestDay.total) }}
            </span>
          </div>
        </div>

        <div class="trend-plot" role="img" [attr.aria-label]="'Daily fees generated vs collected'">
          <div class="trend-y" aria-hidden="true">
            <span
              class="trend-y__tick"
              *ngFor="let tick of yAxisTicks"
              [style.bottom.%]="tick.pct"
            >
              {{ tick.label }}
            </span>
          </div>

          <div class="trend-scroll">
            <div class="trend-body" [style.--cols]="chartDays.length">
              <div class="trend-grid" aria-hidden="true">
                <span
                  class="trend-grid__line"
                  *ngFor="let tick of yAxisTicks"
                  [style.bottom.%]="tick.pct"
                  [class.is-baseline]="tick.value === 0"
                ></span>
              </div>

              <div class="trend-series">
                <div class="trend-bars" role="list">
                  <button
                    type="button"
                    class="trend-bar"
                    *ngFor="let day of chartDays"
                    role="listitem"
                    [class.is-peak]="isBestDay(day)"
                    [class.is-empty]="!(day.fees > 0 || day.total > 0)"
                    [pTooltip]="dayChartTooltip(day)"
                    tooltipPosition="top"
                    (click)="openDailyDetails(day)"
                  >
                    <span
                      class="trend-bar__fill"
                      [class.is-empty]="!(day.fees > 0)"
                      [style.height.%]="feesHeight(day)"
                    ></span>
                    <span
                      class="trend-dot"
                      [class.is-empty]="!(day.total > 0)"
                      [style.bottom.%]="barHeight(day)"
                    ></span>
                  </button>
                </div>

                <svg
                  class="trend-line-svg"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="none"
                  aria-hidden="true"
                >
                  <polyline
                    *ngIf="collectedPolylinePoints"
                    [attr.points]="collectedPolylinePoints"
                    class="trend-line"
                  ></polyline>
                </svg>
              </div>

              <div class="trend-x" aria-hidden="true">
                <span class="trend-x__tick" *ngFor="let day of chartDays">
                  {{ formatShortDate(day.collection_date) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </article>

      <article class="best-day-card" *ngIf="bestDay">
        <p class="kicker">Best day</p>
        <h2>{{ formatDisplayDate(bestDay.collection_date) }}</h2>
        <strong class="best-amount">₹{{ formatRupee(bestDay.total) }}</strong>
        <div class="best-meta">
          <span>{{ bestDay.patients }} patients</span>
          <span>{{ dayRate(bestDay) }}% collected</span>
          <span>₹{{ formatRupee(bestDay.pending) }} pending</span>
        </div>
        <div class="mini-mix">
          <span class="mini-mix__cash" [style.width.%]="cashPct(bestDay)"></span>
          <span class="mini-mix__online" [style.width.%]="onlinePct(bestDay)"></span>
        </div>
        <button type="button" class="col-btn col-btn--soft" (click)="openDailyDetails(bestDay)">
          <i class="pi pi-eye" aria-hidden="true"></i>
          View patients
        </button>
      </article>
    </section>

    <!-- Table -->
    <section class="table-panel" *ngIf="reportView === 'day'">
      <div class="panel-head panel-head--table">
        <div>
          <h2>Daily breakdown</h2>
          <p *ngIf="report.daily_breakdown.length; else idleHint">
            {{ sortedDays.length }} of {{ dayCount }} day{{ dayCount === 1 ? '' : 's' }}
          </p>
          <ng-template #idleHint>
            <p>Choose a range and apply to load collections</p>
          </ng-template>
        </div>

        <div class="table-tools" *ngIf="report.daily_breakdown.length">
          <div class="search-wrap">
            <i class="pi pi-search" aria-hidden="true"></i>
            <input
              type="search"
              class="search-input"
              placeholder="Filter days…"
              [(ngModel)]="tableQuery"
            />
          </div>
        </div>
      </div>

      <div class="table-responsive" *ngIf="sortedDays.length; else emptyState">
        <table class="data-table">
          <thead>
            <tr>
              <th>
                <button type="button" class="th-btn" (click)="setSort('date')">
                  Date <i class="pi" [ngClass]="sortIcon('date')" aria-hidden="true"></i>
                </button>
              </th>
              <th class="text-end">
                <button type="button" class="th-btn" (click)="setSort('patients')">
                  Patients <i class="pi" [ngClass]="sortIcon('patients')" aria-hidden="true"></i>
                </button>
              </th>
              <th class="text-end">Fees</th>
              <th>Payment mix</th>
              <th class="text-end">
                <button type="button" class="th-btn" (click)="setSort('total')">
                  Collected <i class="pi" [ngClass]="sortIcon('total')" aria-hidden="true"></i>
                </button>
              </th>
              <th class="text-end">
                <button type="button" class="th-btn" (click)="setSort('pending')">
                  Pending <i class="pi" [ngClass]="sortIcon('pending')" aria-hidden="true"></i>
                </button>
              </th>
              <th class="text-end">Rate</th>
              <th class="text-end"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let day of sortedDays"
              [class.is-peak]="isBestDay(day)"
              (click)="openDailyDetails(day)"
            >
              <td>
                <div class="date-cell">
                  <span class="date-pill">{{ formatDisplayDate(day.collection_date) }}</span>
                  <span class="peak-tag" *ngIf="isBestDay(day)">Peak</span>
                </div>
              </td>
              <td class="text-end mono">{{ day.patients }}</td>
              <td class="text-end mono">₹{{ formatRupee(day.fees) }}</td>
              <td>
                <div class="row-mix" [pTooltip]="'Cash ₹' + formatRupee(day.cash) + ' · Online ₹' + formatRupee(day.online)" tooltipPosition="top">
                  <div class="row-mix__track">
                    <span class="row-mix__cash" [style.width.%]="cashPct(day)"></span>
                    <span class="row-mix__online" [style.width.%]="onlinePct(day)"></span>
                  </div>
                  <div class="row-mix__nums">
                    <span class="amount-cash">{{ formatCompact(day.cash) }}</span>
                    <span class="amount-online">{{ formatCompact(day.online) }}</span>
                  </div>
                </div>
              </td>
              <td class="text-end mono amount-total">₹{{ formatRupee(day.total) }}</td>
              <td class="text-end">
                <span class="pending-chip" [class.is-clear]="!(day.pending > 0)">
                  ₹{{ formatRupee(day.pending) }}
                </span>
              </td>
              <td class="text-end">
                <span class="rate-chip" [class.is-good]="dayRate(day) >= 90" [class.is-mid]="dayRate(day) >= 60 && dayRate(day) < 90">
                  {{ dayRate(day) }}%
                </span>
              </td>
              <td class="text-end" (click)="$event.stopPropagation()">
                <button type="button" class="col-btn col-btn--soft col-btn--sm" (click)="openDailyDetails(day)">
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #emptyState>
        <div class="empty-state" *ngIf="!loading; else loadingState">
          <div class="empty-visual" aria-hidden="true">
            <span class="empty-bar" *ngFor="let h of [40, 65, 45, 80, 55, 70, 50]" [style.height.%]="h"></span>
          </div>
          <h3>{{ hasGenerated ? 'No days match' : 'No report yet' }}</h3>
          <p>
            {{
              hasGenerated
                ? (tableQuery ? 'Clear the day filter or widen the date range.' : 'Try another range or doctor.')
                : 'Pick a preset or custom dates, then apply.'
            }}
          </p>
          <button
            type="button"
            class="col-btn col-btn--primary"
            *ngIf="!hasGenerated"
            (click)="applyPreset('7d')"
          >
            Load last 7 days
          </button>
          <button
            type="button"
            class="col-btn col-btn--ghost"
            *ngIf="hasGenerated && tableQuery"
            (click)="tableQuery = ''"
          >
            Clear filter
          </button>
        </div>
        <ng-template #loadingState>
          <div class="empty-state">
            <i class="pi pi-spin pi-spinner empty-spinner" aria-hidden="true"></i>
            <h3>Loading collections…</h3>
          </div>
        </ng-template>
      </ng-template>
    </section>

    <section class="table-panel" *ngIf="reportView === 'patient'" aria-label="Patient payments">
      <div class="panel-head panel-head--table">
        <div>
          <h2>Patient payments</h2>
          <p *ngIf="patientReport.patients.length; else patientIdleHint">
            Visits and dues settled in this period. Balance now is what each patient still owes.
          </p>
          <ng-template #patientIdleHint>
            <p>Choose a range and apply to load patient payments</p>
          </ng-template>
        </div>
        <div class="table-tools" *ngIf="patientReport.patients.length">
          <div class="search-wrap">
            <i class="pi pi-search" aria-hidden="true"></i>
            <input
              type="search"
              class="search-input"
              placeholder="Name, number, or phone"
              [(ngModel)]="patientReportQuery"
              (ngModelChange)="onPatientSearch()"
            />
          </div>
        </div>
      </div>

      <div class="patient-summary" *ngIf="patientReport.patients.length">
        <article class="stat-tile">
          <div>
            <span class="stat-tile__label">Patients</span>
            <strong class="stat-tile__value">{{ patientReport.summary.patients | number }}</strong>
          </div>
        </article>
        <article class="stat-tile">
          <div>
            <span class="stat-tile__label">Visits</span>
            <strong class="stat-tile__value">{{ patientReport.summary.visits | number }}</strong>
          </div>
        </article>
        <article class="stat-tile">
          <div>
            <span class="stat-tile__label">Fees</span>
            <strong class="stat-tile__value">₹{{ formatRupee(patientReport.summary.fees) }}</strong>
          </div>
        </article>
        <article class="stat-tile">
          <div>
            <span class="stat-tile__label">Cash</span>
            <strong class="stat-tile__value amount-cash">₹{{ formatRupee(patientReport.summary.cash) }}</strong>
          </div>
        </article>
        <article class="stat-tile">
          <div>
            <span class="stat-tile__label">Online</span>
            <strong class="stat-tile__value amount-online">₹{{ formatRupee(patientReport.summary.online) }}</strong>
          </div>
        </article>
        <article class="stat-tile">
          <div>
            <span class="stat-tile__label">Dues settled</span>
            <strong class="stat-tile__value">₹{{ formatRupee(patientReport.summary.dues_settled) }}</strong>
          </div>
        </article>
        <article class="stat-tile">
          <div>
            <span class="stat-tile__label">Collected</span>
            <strong class="stat-tile__value">₹{{ formatRupee(patientReport.summary.collected) }}</strong>
          </div>
        </article>
        <article class="stat-tile stat-tile--pending">
          <div>
            <span class="stat-tile__label">Balance now</span>
            <strong class="stat-tile__value">₹{{ formatRupee(patientReport.summary.outstanding) }}</strong>
          </div>
        </article>
      </div>

      <div class="table-responsive" *ngIf="filteredPatientPayments.length; else emptyPatientPayments">
        <table class="data-table patient-pay-table">
          <thead>
            <tr>
              <th>
                <button type="button" class="th-btn" (click)="setPatientSort('name')">
                  Patient <i class="pi" [ngClass]="patientSortIcon('name')" aria-hidden="true"></i>
                </button>
              </th>
              <th class="text-end">
                <button type="button" class="th-btn" (click)="setPatientSort('visits')">
                  Visits <i class="pi" [ngClass]="patientSortIcon('visits')" aria-hidden="true"></i>
                </button>
              </th>
              <th class="text-end">Fees</th>
              <th class="text-end">Cash</th>
              <th class="text-end">Online</th>
              <th class="text-end">Dues settled</th>
              <th class="text-end">
                <button type="button" class="th-btn" (click)="setPatientSort('collected')">
                  Collected <i class="pi" [ngClass]="patientSortIcon('collected')" aria-hidden="true"></i>
                </button>
              </th>
              <th class="text-end">Visit pending</th>
              <th class="text-end">
                <button type="button" class="th-btn" (click)="setPatientSort('outstanding')">
                  Balance now <i class="pi" [ngClass]="patientSortIcon('outstanding')" aria-hidden="true"></i>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let patient of pagedPatientPayments">
              <tr (click)="togglePatientPayments(patient.patient_id)" class="patient-pay-row">
                <td>
                  <div class="patient-cell">
                    <span class="patient-avatar">{{ getPatientInitial(patient.patient_name) }}</span>
                    <span>
                      <span class="patient-name">{{ patient.patient_name || '—' }}</span>
                      <span class="patient-meta" *ngIf="patient.patient_number || patient.contact_number">
                        {{ patient.patient_number }}<ng-container *ngIf="patient.patient_number && patient.contact_number"> · </ng-container>{{ patient.contact_number }}
                      </span>
                    </span>
                  </div>
                </td>
                <td class="text-end mono">{{ patient.visits }}</td>
                <td class="text-end mono">₹{{ formatRupee(patient.fees) }}</td>
                <td class="text-end mono amount-cash">₹{{ formatRupee(patient.cash) }}</td>
                <td class="text-end mono amount-online">₹{{ formatRupee(patient.online) }}</td>
                <td class="text-end mono">₹{{ formatRupee(patient.dues_settled) }}</td>
                <td class="text-end mono amount-total">₹{{ formatRupee(patient.collected) }}</td>
                <td class="text-end">
                  <span
                    class="pending-chip"
                    [class.is-clear]="patient.visit_pending === 0"
                    [class.is-extra]="patient.visit_pending < 0"
                  >
                    {{ visitPendingLabel(patient.visit_pending) }}
                  </span>
                </td>
                <td class="text-end">
                  <span class="pending-chip" [class.is-clear]="!(patient.outstanding > 0)">
                    ₹{{ formatRupee(patient.outstanding) }}
                  </span>
                </td>
              </tr>
              <tr *ngIf="expandedPatientId === patient.patient_id">
                <td colspan="9" class="patient-pay-detail">
                  <div class="pay-ledger">
                    <table>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Type</th>
                          <th>Discount</th>
                          <th class="text-end">Fee</th>
                          <th class="text-end">Cash</th>
                          <th class="text-end">Online</th>
                          <th class="text-end">Collected</th>
                          <th>Result</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let line of patient.lines" [ngClass]="lineTone(line)">
                          <td>{{ formatLedgerDate(line.date) }}</td>
                          <td>{{ line.kind === 'dues' ? 'Dues' : 'Visit' }}</td>
                          <td>
                            <span
                              class="pay-off"
                              [class.is-full]="line.discount_percent >= 100"
                              [class.is-none]="!(line.discount_percent > 0)"
                              [attr.title]="line.discount_percent > 0 ? line.discount_percent + '% discount on the visit fee' : 'No discount on this visit'"
                            >{{ line.discount_percent >= 100 ? line.discount_percent + '% Free' : (line.discount_percent > 0 ? line.discount_percent + '%' : 'No discount') }}</span>
                          </td>
                          <td class="text-end mono">{{ line.kind === 'visit' ? '₹' + formatRupee(line.fees) : '—' }}</td>
                          <td class="text-end mono" [class.amount-cash]="line.cash > 0">{{ line.cash > 0 ? '₹' + formatRupee(line.cash) : '—' }}</td>
                          <td class="text-end mono" [class.amount-online]="line.online > 0">{{ line.online > 0 ? '₹' + formatRupee(line.online) : '—' }}</td>
                          <td class="text-end mono">₹{{ formatRupee(line.collected) }}</td>
                          <td>
                            <span class="pay-result" [attr.title]="lineNote(line)">{{ lineResult(line) }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <div class="patient-pager" *ngIf="filteredPatientPayments.length">
        <span>{{ patientPageLabel }}</span>
        <div class="patient-pager__nav">
          <button
            type="button"
            class="col-btn col-btn--ghost col-btn--sm"
            (click)="prevPatientPage()"
            [disabled]="patientPage === 0"
          >
            <i class="pi pi-chevron-left" aria-hidden="true"></i>
            Previous
          </button>
          <span>{{ patientPage + 1 }} / {{ patientPageCount }}</span>
          <button
            type="button"
            class="col-btn col-btn--ghost col-btn--sm"
            (click)="nextPatientPage()"
            [disabled]="patientPage >= patientPageCount - 1"
          >
            Next
            <i class="pi pi-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <ng-template #emptyPatientPayments>
        <div class="empty-state" *ngIf="!loading; else loadingPatientPayments">
          <h3>{{ patientReport.patients.length ? 'No patients match' : 'No patient payments' }}</h3>
          <p>
            {{
              patientReport.patients.length
                ? 'Clear the search or try another name.'
                : 'Try another range or doctor.'
            }}
          </p>
          <button
            type="button"
            class="col-btn col-btn--ghost"
            *ngIf="patientReportQuery"
            (click)="patientReportQuery = ''"
          >
            Clear search
          </button>
        </div>
        <ng-template #loadingPatientPayments>
          <div class="empty-state">
            <i class="pi pi-spin pi-spinner empty-spinner" aria-hidden="true"></i>
            <h3>Loading patient payments…</h3>
          </div>
        </ng-template>
      </ng-template>
    </section>
  </div>

  <!-- Day dialog -->
  <p-dialog
    [(visible)]="visibleModal"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(980px, 96vw)' }"
    styleClass="collections-dialog"
    [contentStyle]="{ padding: '0' }"
  >
    <ng-template pTemplate="header">
      <div class="dialog-header">
        <div>
          <p class="kicker">Day detail</p>
          <h3>{{ formatDisplayDate(selectedDate) }}</h3>
        </div>
        <span class="dialog-count" *ngIf="!detailsLoading">
          {{ dailyDetails.length }} patient{{ dailyDetails.length === 1 ? '' : 's' }}
        </span>
      </div>
    </ng-template>

    <div class="dialog-body">
      <div class="dialog-summary" *ngIf="!detailsLoading && dailyDetails.length">
        <div class="dialog-stat">
          <span>Fees</span>
          <strong>₹{{ formatRupee(dayDetailsTotals.fees) }}</strong>
        </div>
        <div class="dialog-stat">
          <span>Cash</span>
          <strong class="amount-cash">₹{{ formatRupee(dayDetailsTotals.cash) }}</strong>
        </div>
        <div class="dialog-stat">
          <span>Online</span>
          <strong class="amount-online">₹{{ formatRupee(dayDetailsTotals.online) }}</strong>
        </div>
        <div class="dialog-stat">
          <span>Received</span>
          <strong>₹{{ formatRupee(dayDetailsTotals.received) }}</strong>
        </div>
        <div class="dialog-stat">
          <span>Pending</span>
          <strong [class.is-pending]="dayDetailsTotals.pending > 0">₹{{ formatRupee(dayDetailsTotals.pending) }}</strong>
        </div>
      </div>

      <div class="dialog-toolbar" *ngIf="!detailsLoading && dailyDetails.length">
        <div class="search-wrap">
          <i class="pi pi-search" aria-hidden="true"></i>
          <input
            type="search"
            class="search-input"
            placeholder="Search patients…"
            [(ngModel)]="patientQuery"
          />
        </div>
      </div>

      <div class="dialog-loading" *ngIf="detailsLoading; else detailsTable">
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        <span>Loading patients…</span>
      </div>

      <ng-template #detailsTable>
        <div class="table-responsive dialog-scroll" *ngIf="filteredPatients.length; else noPatients">
          <table class="data-table">
            <thead>
              <tr>
                <th>Patient</th>
                <th class="text-end">Fees</th>
                <th class="text-end">Cash</th>
                <th class="text-end">Online</th>
                <th class="text-end">Received</th>
                <th class="text-end">Pending</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of filteredPatients">
                <td>
                  <div class="patient-cell">
                    <span class="patient-avatar">{{ getPatientInitial(p.patient_name) }}</span>
                    <span class="patient-name">{{ p.patient_name || '—' }}</span>
                  </div>
                </td>
                <td class="text-end mono">₹{{ formatRupee(p.visit_fees) }}</td>
                <td class="text-end mono amount-cash">₹{{ formatRupee(p.received_cash) }}</td>
                <td class="text-end mono amount-online">₹{{ formatRupee(p.received_online) }}</td>
                <td class="text-end mono amount-total">₹{{ formatRupee(p.total_received) }}</td>
                <td class="text-end">
                  <span class="pending-chip" [class.is-clear]="!(p.pending > 0)">
                    ₹{{ formatRupee(p.pending) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #noPatients>
          <div class="empty-state empty-state--compact">
            <p *ngIf="dailyDetails.length; else trulyEmpty">No patients match “{{ patientQuery }}”.</p>
            <ng-template #trulyEmpty>
              <p>No patient payments recorded for this day.</p>
            </ng-template>
          </div>
        </ng-template>
      </ng-template>
    </div>

    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <button
          type="button"
          class="col-btn col-btn--excel"
          [disabled]="!dailyDetails.length || exportingDaily"
          (click)="exportDailyPatientDetails(selectedDate)"
        >
          <i class="pi" [ngClass]="exportingDaily ? 'pi-spin pi-spinner' : 'pi-file-excel'" aria-hidden="true"></i>
          Export Excel
        </button>
        <button type="button" class="col-btn col-btn--ghost" (click)="visibleModal = false">Close</button>
      </div>
    </ng-template>
  </p-dialog>
</div>
